export class TierLevels {
  public static Default = 'DEFAULT';
  public static Mvp = 'MVP';
  public static Legend = 'LEGEND';
  public static AllStar = 'ALL_STAR';
  public static Pro = 'PRO';
}
